// src/helpers/SettingsDropdown.tsx
import React from 'react';
import DropDownButton from 'devextreme-react/drop-down-button';
import { fetchSettingsFromApi } from './settingsHelper';
import { SavedSetting } from '../components/library/page-setting/SettingsPopup';

interface SettingsDropdownProps {
  savedSettings: SavedSetting[];
  setSavedSettings: React.Dispatch<React.SetStateAction<SavedSetting[]>>;
  settingsDropdownOpened: boolean;
  setSettingsDropdownOpened: React.Dispatch<React.SetStateAction<boolean>>;
  handleSettingsItemClick: (e: any) => void;
  settingPage: string;
  settingObject: string;
  t: (key: string) => string;
}

const SettingsDropdown: React.FC<SettingsDropdownProps> = ({
  savedSettings,
  setSavedSettings,
  settingsDropdownOpened,
  setSettingsDropdownOpened,
  handleSettingsItemClick,
  settingPage,
  settingObject,
  t,
}) => {
  return (
    <DropDownButton
      icon="optionsgear"
      items={[
        ...savedSettings.map((setting) => ({
          text: setting.settingName,
          icon: setting.isDefault ? "dx-icon-check" : "dx-icon-settings",
          value: setting,
        })),
        { text: t("changeSettings"), icon: "dx-icon-optionsgear", value: "modify" },
      ]}
      onItemClick={handleSettingsItemClick}
      onButtonClick={async () => {
        // Dropdown'a tıklandığında API çağrısı yaparak tüm ayarları çekiyoruz.
        const settings = await fetchSettingsFromApi(settingPage, settingObject);
        console.log('Fetched settings:', settings);
        setSavedSettings(settings);
        setSettingsDropdownOpened(true);
      }}
      dropDownOptions={{
        width: "auto",
        hideOnOutsideClick: true,
        animation: { show: { duration: 0 }, hide: { duration: 0 } },
        onHiding: () => setSettingsDropdownOpened(false),
      }}
      opened={settingsDropdownOpened}
      stylingMode="text"
      itemRender={(item: any) => {
        const defaultContent = (
          <div>
            <span className={`dx-icon ${item.icon}`} style={{ fontSize: "17px", width: "17px", height: "17px" }} />
            <span style={{ whiteSpace: "nowrap" }}>{item.text}</span>
          </div>
        );
        if (item.value === "modify") {
          return (
            <>
              <hr
                style={{
                  margin: "0px 0",
                  border: "none",
                  borderTop: "1px solid #eee",
                  position: "relative",
                  top: "-6px",
                }}
              />
              {defaultContent}
            </>
          );
        }
        return defaultContent;
      }}
    />
  );
};

export default SettingsDropdown;
